

































































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Lot, ApiError, Media, User, isVerificationRequired } from '@/api';
import { snackModule, auctionModule, authModule } from '@/store';
import VerificationGateDialog from '@/components/auth/VerificationGateDialog.vue';

@Component({
  components: { VerificationGateDialog },
})
export default class extends Vue {
  @Prop({ required: false }) readonly selectedLot: Lot;

  loading: boolean = false;

  bidValue: number | null = null;
  currentBid: string = '';
  validBid: boolean = false;
  bidSuccess: boolean = false;
  showGate: boolean = false;

  requiredRule = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',

    (v: string) =>
      v8n()
        .string()
        .currency()
        .test(v) || 'Bid value must be greater than 0',

    (v: string) =>
      v8n()
        .string()
        .decimal()
        .test(v) || 'Bid value must be a whole dollar, no cents',
  ];

  get hasBid() {
    if (
      !this.selectedLot ||
      !this.selectedLot.id ||
      !this.selectedLot.auction.id
    ) {
      return false;
    }
    const bid =
      auctionModule.bids[this.selectedLot.auction.id][this.selectedLot.id];
    if (bid) {
      const value = bid.value / 100;
      this.currentBid = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
      }).format(value);
      return true;
    } else {
      return false;
    }
  }

  async addBid() {
    if (!authModule.user || !this.selectedLot) {
      return;
    }
    // @ts-ignore
    const bidValue = this.$parseCurrency(this.bidValue);

    if (!this.validBid) {
      return;
    }

    try {
      this.loading = true;
      await auctionModule.addBid({ lot: this.selectedLot, value: bidValue });
      this.bidSuccess = true;
      authModule.trackEvent({
        gtag: this.$gtag,
        eventAction: 'add_bid',
        eventCategory: 'engagement',
        eventLabel: this.selectedLot.title,
      });
    } catch (err) {
      // A gated bidder gets the popup rather than the generic failure: it is
      // the one bid error they can actually do something about. Keyed off the
      // error code, never the status - see `isVerificationRequired`.
      if (isVerificationRequired(err)) {
        this.showGate = true;
      }
    } finally {
      this.loading = false;
    }
  }

  close() {
    this.$emit('close-bid');
  }

  async beforeMount() {
    const currency = () => {
      // @ts-ignore
      return (value: string) => this.$parseCurrency(value) > 0;
    };
    const decimal = () => {
      return (value: string) => {
        // @ts-ignore
        const centsValue = this.$parseCurrency(value);
        const dollarValue = centsValue / 100;
        return dollarValue % 1 === 0;
      };
    };
    v8n.extend({ currency, decimal });
  }
}
